import { useState, useParams, FaBoxOpen, BiCategory, useRef, ToastContainer, MdErrorOutline, FaArrowAltCircleRight, overlayStyle, loaderStyle, FaFilePdf, FaFileImage, FaFileExcel, FaFileAlt, FaTimes, FiDownload, FiTrash2, noUser } from '../../common/common';

import { FaCopy, FaRegEdit } from 'react-icons/fa';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { FiEdit } from 'react-icons/fi';
import Modal from 'react-bootstrap/Modal';
import MidProfile from '../../middleware/Profile/MidProfile';
import { IoMdPhonePortrait } from 'react-icons/io';
import Select from "react-select";
import ProfilePicModal from '../Components/ProfilePicModal';
import { validateImageFile } from '../../Utils/validateFile';
import { showToast } from '../../Utils/toastUtils';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import axiosJWT from '../../secureAPI/axiosJWT';
import PencilIcon from '../Components/PencilIcon';
import { useEffect } from 'react';
const Profile = () => {
    const { type } = useParams();
    // console.log(type)
    const [issidebarOpen, setIssidebarOpen] = useState(true);

    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { GetCompanyProfileEdit, handleChange, handleClose, handleShow, lgshow, formData, setFormdata, countryData, getCities, getStates, handleCityChange, handleCountryChange, handleStateChange, selectedCity, selectedCountry, selectedState, companyData, GetUserData, modalcondition, handleEditSubmit, error, handleCompanyChange, handleCompanyEdit, handleFileChange, selectedImage, imagePreview, GetDocumentEdit, users, userPlan, Remainuser, subUser, showEditUserinfoModal, setshowEditUserinfoModal, handleUserInfoModalClose, handleGenralInfoModalShow, handleGetState, stateData, cityData, handleSetCityId, EditedState, EditedCity, showEditBusinessinfoModal, setShowEditBusinessinfoModal, handleCompanyDataEditSubmit, uploadedFiles, setUploadedFiles, removeFile, documents, setDocuments, getFileIcon, handleDownload, handleDeleteDocs, isLoading, setisLoading, isDisabled, setisDisabled } = MidProfile(type);


    const [isOpen, setIsOpen] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const avatarUrl = useRef('../../assets/images/noUser.png');
    const [profilepic, setProfilepic] = useState(`${process.env.REACT_APP_API_URL}/ assets/ images / noUser.png`);
    const toggleSidebar = () => setIsOpen(!isOpen);
    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var CompanyName = users[0]['CompanyName'];
        var userAddress1 = users[0]['Address1'];
        var userAddress2 = users[0]['Address2'];
        var Mobile = users[0]['Mobile'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];
        var CityName = users[0].City.name;
        var StateName = users[0]['StateName'];
        var CountryName = users[0]['CountryName'];
        var Pincode = users[0]['Pincode'];
        var ActiveUser = users[0]["Status"]

    }
    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }

    const updateAvatar = async (file, imgSrc) => {
        // Validate the image file
        const validation = validateImageFile(file);
        if (!validation.valid) {
            showToast(validation.msg, 'error');
            return;
        }
        // Proceed with updating avatar if file is valid
        avatarUrl.current = imgSrc;
        setProfilepic(file);
        try {
            StartLoading(setisLoading, setisDisabled);
            const formData = new FormData();
            formData.append("userImage", file);


            UpdateUserProfileImage(formData, imgSrc)
        } catch (err) {
            showToast('Something went wrong! Please try again later', 'error');
            StopLoading(setisLoading, setisDisabled);
        } finally {
            StopLoading(setisLoading, setisDisabled);
        }
    };


    const UpdateUserProfileImage = async (formData, imgSrc) => {
        try {
            StartLoading(setisLoading, setisDisabled);
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/UpdateUserProfileImage`, formData, { withCredentials: true })
                .then((res) => {
                    StopLoading(setisLoading, setisDisabled);
                    showToast(res.data.message, 'success');
                    setProfilepic(imgSrc);
                })
                .catch((err) => {
                    showToast('Something went wrong! Please try again later', 'error');
                    StopLoading(setisLoading, setisDisabled);
                });
        } catch (err) {
            showToast('Something went wrong! Please try again later', 'error');
            StopLoading(setisLoading, setisDisabled);
        }
    };

    useEffect(() => {
        if (Array.isArray(users) && users.length > 0) {


            if (ProfilePic !== '') {
                setProfilepic(`${process.env.REACT_APP_API_URL}/api/uploads/user/${ProfilePic}`);
            }
            else {
                setProfilepic(noUser);
            }
        }
    }, [users, ProfilePic]);


    return (
        <div className='md:flex md:flex-row md:w-full'>
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="col-start-1 col-end-13">
                    <div className=" p-2 text-xl text-[#1e3a8a]">
                        <div className='px-3'>
                            <h1 className=' text-lg text-theme-color-text font-bold'> Profile</h1>
                            <p className=' text-gray-600 text-[16px] '>A product category is a group of similar type of products. Ex. Menswear,Womenswear,Childrenswear</p>
                        </div>
                    </div>
                </div>
                <div className="md:m-6 flex justify-center">
                    <div className="w-full md:w-3/6 bg-white rounded overflow-hidden border">
                        <div className="space-y-6">
                            <div className="bg-white rounded-lg space-y-4">

                                <div className="flex justify-between items-center border-b px-4 py-2.5">
                                    <h3 className="text-xl font-semibold">General Info</h3>

                                    {ActiveUser === 1 &&
                                        <button className="flex items-center justify-center p-2 rounded-full text-blue-600 hover:bg-blue-100 transition" title="Edit" onClick={GetCompanyProfileEdit} >
                                            <FiEdit className="w-5 h-5" />
                                        </button>
                                    }
                                </div>
                                {/* <div className="flex flex-col items-center mt-4">
                                    <img
                                        src={formData.profilePhoto || "/default-avatar.png"}
                                        alt="Profile"
                                        className="w-24 h-24 rounded-full object-cover border border-gray-300"
                                    />
                                </div> */}
                                <div className="md:flex md:justify-center mdg::justify-end mt-4 md:mt-0">
                                    <div className="flex flex-col items-center relative">
                                        <img
                                            src={profilepic || noUser}
                                            alt="Avatar"
                                            className="w-24 h-24 rounded-full object-cover border border-gray-300"
                                        />

                                        {ActiveUser === 1 &&
                                            <button
                                                className="absolute -bottom-5 md:-bottom-3 left-0 right-0 m-auto w-fit p-[.35rem] rounded-full bg-white hover:bg-gray-200 border border-gray-200"
                                                title="Change photo"
                                                onClick={() => setModalOpen(true)}
                                            >
                                                <PencilIcon />
                                            </button>
                                        }

                                        
                                    </div>

                                    {modalOpen && (
                                        <ProfilePicModal
                                            updateAvatar={updateAvatar}
                                            closeModal={() => setModalOpen(false)}
                                        />
                                    )}
                                </div>
                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm"> Name</label>
                                        <p className="text-gray-800">{formData.fullName}</p>
                                    </div>
                                </div>

                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Email</label>
                                        <p className="text-gray-800">{formData.emailAddress}</p>
                                    </div>
                                </div>
                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Phone Number</label>
                                        <p className="text-gray-800">{formData.contactNumber}</p>
                                    </div>
                                </div>

                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Address</label>
                                        <p className="text-gray-800">{formData.address1}{formData.address2}</p>
                                    </div>
                                </div>

                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">City</label>
                                        <p className="text-gray-800">{formData.cityName}</p>
                                    </div>
                                </div>
                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">State</label>
                                        <p className="text-gray-800">{formData.stateName}</p>
                                    </div>
                                </div>
                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Country</label>
                                        <p className="text-gray-800">{formData.countryName}</p>
                                    </div>
                                </div>

                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">ZIP Code / Pin Code</label>
                                        <p className="text-gray-800">{formData.pincode}</p>
                                    </div>
                                </div>



                                <div className="pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Selzor Application ID</label>
                                        <div className="flex items-center gap-2 text-gray-800">
                                            <p className="">{AppID}</p>
                                            <button
                                                className="text-indigo-600 hover:text-indigo-800 p-1.5 rounded-full transition-colors duration-300 transform hover:bg-indigo-100"
                                                aria-label="Copy Remote Company ID"
                                                onClick={() => navigator.clipboard.writeText(AppID)}
                                            >
                                                <FaCopy size={16} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="md:m-6 flex justify-center">
                    <div className="w-full md:w-3/6 bg-white rounded overflow-hidden border">
                        <div className="space-y-6">
                            <div className="bg-white rounded-lg space-y-4">
                                <div className="flex justify-between items-center border-b px-4 py-2.5">
                                    <h3 className="text-xl font-semibold">Company Details Setting </h3>

                                    {ActiveUser === 1 &&
                                        <button className="flex items-center justify-center p-2 rounded-full text-blue-600 hover:bg-blue-100 transition" title="Edit" onClick={GetUserData}  >
                                            <FiEdit className="w-5 h-5" />
                                        </button>
                                    }
                                </div>

                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Company Name</label>
                                        <p className="text-gray-800">{companyData.companyName}</p>
                                    </div>
                                </div>

                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Phone Number</label>
                                        <p className="text-gray-800">{companyData.officeNumber}</p>
                                    </div>
                                </div>

                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Company Initial Code</label>
                                        <p className="text-gray-800">{companyData.Initials}</p>
                                    </div>
                                </div>

                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Web Site</label>
                                        <p className="text-gray-800">{companyData.Website}</p>
                                    </div>
                                </div>

                                <div className="border-b pb-2.5">
                                    <div className="flex justify-between items-center px-4">
                                        <label className="text-gray-500 font-medium text-sm">Company GST Number</label>
                                        <p className="text-gray-800">
                                            {companyData.GSTNumber ? (companyData.GSTNumber) : (
                                                <span className="text-red-600 text-xs bg-red-50 p-1 border border-red-600 rounded font-semibold">
                                                    Missing Details
                                                </span>
                                            )}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="md:m-6 flex justify-center">
                    <div className="w-full md:w-3/6 bg-white rounded overflow-hidden border">
                        <div className="space-y-6">
                            <div className="bg-white rounded-lg space-y-4">

                                <div className="flex justify-between items-center border-b px-4 py-2.5">
                                    <h3 className="text-xl font-semibold">Document Detail</h3>

                                </div>

                                <div className="space-y-4">
                                    {documents.map((doc) => (
                                        <div
                                            key={doc.id}
                                            className="flex items-center justify-between p-4 bg-white rounded-lg shadow hover:shadow-md transition-shadow"
                                        >
                                            <div className="flex items-center space-x-4">
                                                {getFileIcon(doc.productPhoto)}
                                                <div>
                                                    <p className="font-medium text-gray-800">{doc.productPhoto}</p>
                                                    <p className="text-sm text-gray-500">
                                                        {Math.round(doc.productPhoto?.size / 1024) || 'Unknown'} KB • {doc.productHSN}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className="flex space-x-2">
                                                <button
                                                    onClick={() => handleDownload(doc)}
                                                    className="p-2 text-blue-500 hover:text-blue-700 hover:bg-blue-50 rounded-full transition-colors"
                                                    title="Download"
                                                >
                                                    <FiDownload className="text-xl" />
                                                </button>
                                                <button
                                                    onClick={() => handleDeleteDocs(doc.id)}
                                                    className="p-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-full transition-colors"
                                                    title="Delete"
                                                >
                                                    <FiTrash2 className="text-xl" />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* <Modal size="xl" show={lgshow} onHide={handleClose}> */}
            <Modal size="xl" show={showEditUserinfoModal} onHide={() => handleUserInfoModalClose} aria-labelledby="example-modal-sizes-title-lg">

                <Modal.Body >
                    <div className="relative border-b border-slate-200/60 py-2">
                        <label className=" text-lg"> Edit General Information</label>
                        <div className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer" onClick={() => handleUserInfoModalClose()}> ESC / Close </div>
                    </div>

                    <div className='p-3'>
                        {modalcondition === 1 && (
                            <div>
                                <div className='row'>
                                    <div className="container m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-2">
                                        <div>
                                            <label className="my-3 flex flex-row">
                                                <span className="block text-sm font-medium text-slate-700">Full Name </span>

                                            </label>
                                            <div class='bg-transparent  mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                                                <FaBoxOpen className='text-theme-color-yellow' />
                                                <input
                                                    className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                    type="text"
                                                    name="fullName"
                                                    id="fullName"
                                                    placeholder="Enter full name"
                                                    autoComplete="new-password"
                                                    value={formData.fullName}
                                                    onChange={handleChange}

                                                />
                                                {error.FullName &&
                                                    <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                }
                                            </div>
                                            {error.FullName && <p className='my-2 px-2 text-red-600 text-xs'>{error.FullName}</p>}
                                        </div>
                                        <div>
                                            <label className="my-3 flex flex-row">
                                                <span className="block text-sm font-medium text-slate-700">Mobile Number</span>
                                            </label>
                                            <div class='bg-transparent  mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                                                <FaBoxOpen className='text-theme-color-yellow' />
                                                <input
                                                    className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                    type="text"
                                                    name="contactNumber"
                                                    id="contactNumber"
                                                    placeholder="Enter contact number"
                                                    autoComplete="new-password"
                                                    value={formData.contactNumber}
                                                    onChange={handleChange}

                                                />
                                                {error.ContactNumber &&
                                                    <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                }
                                            </div>
                                            {error.ContactNumber && <p className='my-2 px-2 text-red-600 text-xs'>{error.ContactNumber}</p>}
                                        </div>
                                        <div>
                                            <label className="my-3 flex flex-row">
                                                <span className="block text-sm font-medium text-slate-700">Email Address</span>
                                            </label>
                                            <div class='bg-transparent  mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                                                <FaBoxOpen className='text-theme-color-yellow' />
                                                <input
                                                    className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                    type="text"
                                                    name="emailAddress"
                                                    id="emailAddress"
                                                    placeholder="Enter email address"
                                                    autoComplete="new-password"
                                                    value={formData.emailAddress}
                                                    onChange={handleChange}

                                                />
                                                {error.EmailAddress &&
                                                    <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                }
                                            </div>
                                            {error.EmailAddress && <p className='my-2 px-2 text-red-600 text-xs'>{error.EmailAddress}</p>}
                                        </div>
                                        <div>
                                            <label className="my-3 flex flex-row">
                                                <span className="block text-sm font-medium text-slate-700">Address Line 1</span>
                                            </label>
                                            <div class='bg-transparent  mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                                                <FaBoxOpen className='text-theme-color-yellow' />
                                                <input
                                                    className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                    type="text"
                                                    name="address1"
                                                    id="address1"
                                                    placeholder="Enter address line 1"
                                                    autoComplete="new-password"
                                                    value={formData.address1}
                                                    onChange={handleChange}

                                                />
                                                {error.Address1 &&
                                                    <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                }
                                            </div>
                                            {error.Address1 && <p className='my-2 px-2 text-red-600 text-xs'>{error.Address1}</p>}
                                        </div>
                                        <div>
                                            <label className="my-3 flex flex-row">
                                                <span className="block text-sm font-medium text-slate-700">Address Line 2</span>
                                            </label>
                                            <div class='bg-transparent  mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                                                <FaBoxOpen className='text-theme-color-yellow' />
                                                <input
                                                    className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                    type="text"
                                                    name="address2"
                                                    id="address2"
                                                    placeholder="Enter address line 2 "
                                                    autoComplete="new-password"
                                                    value={formData.address2}
                                                    onChange={handleChange}

                                                />
                                                {error.Address2 &&
                                                    <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                }
                                            </div>
                                            {error.Address2 && <p className='my-2 px-2 text-red-600 text-xs'>{error.Address2}</p>}
                                        </div>

                                        {(users.length > 0 && users[0]?.IsIndian === 0) ? <div>
                                            <label className="my-3 flex flex-row">
                                                <span className="block text-sm font-medium text-slate-700">Country</span>
                                            </label>
                                            <div class='bg-transparent  mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                                                <Select onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }} className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 " options={countryData} placeholder="Select Country" onChange={handleGetState} />
                                            </div>
                                        </div> : null}


                                        <div>
                                            <label className="my-3 flex flex-row">
                                                <span className="block text-sm font-medium text-slate-700">States  </span>
                                            </label>
                                            <div class='bg-transparent  mb-1  relative  w-full rounded-md'>
                                                <Select
                                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                                    className="my-1"
                                                    options={stateData}
                                                    onChange={handleStateChange}
                                                    value={selectedState}
                                                    getOptionValue={option => option.value}
                                                    isClearable
                                                    placeholder="Select State"
                                                />
                                            </div>
                                        </div>
                                        <div >
                                            <label className="my-3 flex flex-row">
                                                <span className="block text-sm font-medium text-slate-700">City</span>
                                            </label>
                                            <div class='bg-transparent  mb-1  relative  w-full rounded-md'>
                                                <Select
                                                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); } }}
                                                    className="my-1"
                                                    options={cityData}
                                                    onChange={handleCityChange}
                                                    value={selectedCity}
                                                    getOptionValue={option => option.value}
                                                    isClearable
                                                    placeholder="Select City"
                                                />
                                            </div>
                                            {/* <Select onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault();}}} className=" my-1" value={EditedCity} options={cityData} placeholder="Select City" onChange={handleSetCityId} /> */}
                                        </div>

                                        <div>
                                            <label className="my-3 flex flex-row">
                                                <span className="block text-sm font-medium text-slate-700">Pincode</span>
                                            </label>
                                            <div class='bg-transparent  mb-1 flex relative  border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md'>
                                                <FaBoxOpen className='text-theme-color-yellow' />
                                                <input
                                                    className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                    type="text"
                                                    name="pincode"
                                                    id="pincode"
                                                    placeholder="Enter pincode"
                                                    autoComplete="new-password"
                                                    value={formData.pincode}
                                                    onChange={handleChange}

                                                />
                                                {error.pincode &&
                                                    <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                                                }
                                            </div>
                                            {error.pincode && <p className='my-2 px-2 text-red-600 text-xs'>{error.pincode}</p>}
                                        </div>


                                    </div>
                                </div>



                                <div className="flex justify-end m-4">
                                    <button className="px-3 text-sm text-white py-2 bg-sky-800 flex rounded font-semibold" onClick={handleEditSubmit} >
                                        <FaRegEdit className="mr-3 mt-0.5" size={15} />
                                        Update
                                    </button>
                                </div>
                            </div>
                        )}

                        {modalcondition === 2 && (
                            <div>

                                <div className='grid grid-cols-3 gap-4'>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Company Name <span className='text-red-600'>*</span></label>
                                        <div className="relative mt-1">
                                            <input type="text" placeholder="Enter Company Name" className="input_css w-full px-3 py-2 border rounded" id='companyname' name='companyName' value={companyData.companyName} onChange={handleCompanyChange} />
                                            <IoMdPhonePortrait className="absolute right-2 top-2 text-gray-500" />
                                            {error.companyName && (<p className='text-red-600 text-sm'>{error.companyName}</p>)}
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Contact Number <span className='text-red-600'>*</span></label>
                                        <div className="relative mt-1">
                                            <input type="number" placeholder="Enter Contact Number" className="input_css w-full px-3 py-2 border rounded" id='officeNumber' name='officeNumber' value={companyData.officeNumber} onChange={handleCompanyChange} />
                                            <IoMdPhonePortrait className="absolute right-2 top-2 text-gray-500" />
                                            {error.officeNumber && (<p className='text-red-600 text-sm'>{error.officeNumber}</p>)}
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Initial Code <span className='text-red-600'>*</span></label>
                                        <div className="relative mt-1">
                                            <input type="text" placeholder="Enter Initial Code" className="input_css w-full px-3 py-2 border rounded" id='Initials' name='Initials' value={companyData.Initials} onChange={handleCompanyChange} />
                                            <IoMdPhonePortrait className="absolute right-2 top-2 text-gray-500" />
                                            {error.Initials && (<p className='text-red-600 text-sm'>{error.Initials}</p>)}
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Website <span className='text-red-600'>*</span></label>
                                        <div className="relative mt-1">
                                            <input type="text" placeholder="Enter Website" className="input_css w-full px-3 py-2 border rounded" id='Website' name='Website' value={companyData.Website} onChange={handleCompanyChange} />
                                            <IoMdPhonePortrait className="absolute right-2 top-2 text-gray-500" />
                                            {error.Website && (<p className='text-red-600 text-sm'>{error.Website}</p>)}
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700">Company GST <span className='text-red-600'>*</span></label>
                                        <div className="relative mt-1">
                                            <input type="text" placeholder="Enter Website" className="input_css w-full px-3 py-2 border rounded " id='GSTNumber' name='GSTNumber' value={companyData.GSTNumber} onChange={handleCompanyChange} />
                                            <IoMdPhonePortrait className="absolute right-2 top-2 text-gray-500" />
                                            {error.GSTNumber && (<p className='text-red-600 text-sm'>{error.GSTNumber}</p>)}
                                        </div>
                                    </div>



                                </div>

                                <div className="flex justify-end m-4">
                                    <button className="px-3 text-sm text-white py-2 bg-sky-800 flex rounded font-semibold" onClick={handleCompanyDataEditSubmit} >
                                        <FaRegEdit className="mr-3 mt-0.5" size={15} />
                                        Update
                                    </button>
                                </div>
                            </div>
                        )}


                    </div>
                </Modal.Body>
            </Modal>

            <ToastContainer />
        </div >

    );

}

export default Profile